import * as yup from "yup";

export const schemaAccountInformation = yup.object({
  username: yup
    .string()
    .min(3, "Username must be at least 3 characters")
    .max(20, "Username cannot exceed 20 characters")
    .matches(/^[A-Za-z0-9_]+$/, "Username can only contain letters, numbers, and underscores")
    .required("Please enter username"),

  firstName: yup
    .string()
    .trim()
    .transform((v) => (v === "" ? undefined : v))
    .min(3, "First name must be at least 3 characters")
    .max(20, "Maximum 20 characters")
    .matches(/^[a-zA-Z\s-]+$/, {
      message: "Only letters, spaces, and hyphens are allowed",
      excludeEmptyString: true,
    })
    .optional(),

  lastName: yup
    .string()
    .trim()
    .transform((v) => (v === "" ? undefined : v))
    .min(3, "Last name must be at least 3 characters")
    .max(20, "Maximum 20 characters")
    .matches(/^[a-zA-Z\s-]+$/, {
      message: "Only letters, spaces, and hyphens are allowed",
      excludeEmptyString: true,
    })
    .optional(),

  email: yup
    .string()
    .required("Please enter a valid email address")
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      "Please enter a valid email address"
    ),

  bio: yup
    .string()
    .trim()
    .transform((v) => (v === "" ? undefined : v))
    .min(3, "Bio must be at least 3 characters")
    .max(500, "Maximum 500 characters")
    .optional(),
});

export type AccountInfoSchema = yup.InferType<typeof schemaAccountInformation>;
